import { render, staticRenderFns } from "./CommonComponentsSampleView.vue?vue&type=template&id=354dc51a&scoped=true&"
import script from "./CommonComponentsSampleView.vue?vue&type=script&lang=js&"
export * from "./CommonComponentsSampleView.vue?vue&type=script&lang=js&"
import style0 from "./CommonComponentsSampleView.vue?vue&type=style&index=0&id=354dc51a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354dc51a",
  null
  
)

export default component.exports